import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';
import SearchBars from 'components/SearchBars';
import Card from 'components/Card';
import Page from 'components/Page';
import SearchBarWrapper from 'components/SearchBarWrapper';
import { observer, inject } from 'mobx-react';
import { LoadError, Loading } from 'components/Tables/ScheduleList';
import JobsTable from 'components/Tables/Jobs';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

@inject('store', 'jobStore', 'viewStore') @observer
class JobsIndexPage extends Component {

  render() {
    let content;
    const { jobStore, viewStore } = this.props;
    const {
      props: {
        jobStore: {
          jobs: {
            isLoading,
            isError
          }
        }
      }
    } = this;
    if (isLoading && !isError) {
      content = <Loading variant="jobs" noun="jobs" />;
    }
    if (isError && !isLoading) {
      content = (
        <LoadError
          noun="jobs"
          search={viewStore.jobSearch}
          onRetry={() => jobStore.loadJobs()}
          onNarrow={() => { viewStore.narrowJobDateRange(3); viewStore.jobs(); }}
        />
      );
    }
    if (!isError && !isLoading) {
      content = <JobsTable />
    }
    return(
      <div>
        <Helmet>
          <title>Jobs | FieldNexus</title>
        </Helmet>
        <PageWrapGray>
          <SearchBars.Job key={this.props.viewStore.jobFiltersVersion} />
          <Card>
            {content}
          </Card>
        </PageWrapGray>
      </div>
    )
  }

};

export default JobsIndexPage;